// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/tdg-event-schema',
  type: 'object',
  required: ['id', 'creatorId'],
  properties: {
    id: {
      type: 'integer',
    },
    creatorId: {
      type: 'integer',
    },
    created: {
      type: 'string',
      format: 'date-time',
    },
    modifierId: {
      type: 'integer',
      nullable: true,
    },
    modified: {
      type: 'string',
      format: 'date-time',
      nullable: true,
    },
    name: {
      type: 'string',
      nullable: true,
    },
    externalId: {
      type: 'string',
      format: 'uuid',
    },
    eventTimeStart: {
      type: 'string',
      format: 'date-time',
    },
    eventTimeEnd: {
      type: 'string',
      format: 'date-time',
    },
    registrationUntil: {
      type: 'string',
      format: 'date-time',
    },
    showUntil: {
      type: 'string',
      format: 'date-time',
    },
    feedbackUntil: {
      type: 'string',
      format: 'date-time',
    },
  },
} as IJSONSchema;

export default schema;
